import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
import { PROCESS_STEPS } from "../data/content";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-28 lg:py-36 bg-navy-light/40 border-y border-white/5">
      <div className="absolute inset-0 grid-pattern opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          testId="process-heading"
          eyebrow="How we do it"
          title="A four-step journey to online success"
          description="You are the author of your own business. We work with you, involving you in every step of the way — from first conversation to launch day."
        />

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-4 gap-6 relative">
          {/* connecting line on desktop */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-signal/60 via-white/10 to-signal/60" />
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={step.number}
              data-testid={`process-step-${step.number}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12, ease: "easeOut" }}
              className="relative glass rounded-2xl p-7 hover:border-signal/60 transition-colors duration-300"
            >
              <span className="font-mono text-signal text-sm tracking-[0.25em]">{step.number}</span>
              <h3 className="mt-4 font-display text-xl font-semibold text-white">{step.title}</h3>
              <p className="mt-3 text-sm md:text-base text-muted leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
